module.exports = __webpack_public_path__ + "static/project-3-1-f59dceaa786974ba6242b5c903250f21.jpg";